        //toggle main accordion sections on apply form
        $(function() {
            $('.help-accordion-link').on('click', function(event) {
                $(event.target).closest('.help-accordion-header').find('.help-accordion-status').toggleClass('closed');
                $(event.target).closest('.help-accordion-header').siblings().closest('.help-accordion').toggleClass('closed').slideToggle(250);
            });
        });

        //faq dropdown functionality
        $(function() {
            $('.help-faq-question-text').on('click', function(event) {
            $('.help-faq-accordion').show();
            var faqWrapper = $(event.target).closest('.help-faq-wrapper');
            var faqAnswer = faqWrapper.find('.help-faq-answer-text');
            var faqAnswerId = faqWrapper.find('.help-faq-title').attr('id');

            //toggle the open close of the plus symbol
            $(this).toggleClass('rotate');
        
            // Close all other open FAQ sections and rotate the plus symbol
            $('.help-faq-answer-text.open').not(faqAnswer).slideUp(250).removeClass('open');
            $('.help-faq-question-text.rotate').not($(this)).removeClass('rotate');
            
            // Open/close the clicked FAQ section
            faqAnswer.slideToggle(250).toggleClass('open');
            });
        });

        $(document).ready(function () {
            // Attach a click event handler to the "click-me" element
            $(".click-me").click(function () {
                // Toggle the "hidden" class on the "toggle-me" element
                $(".toggle-me").slideToggle('fast').toggleClass("hidden");
            });
        });